const MINUTE = 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export const getTimeSince = (timestamp: number) => {
  const now = Date.now();
  const diff = Math.round((now - timestamp) / 1000);

  const days = Math.floor(diff / DAY);
  const hours = Math.floor((diff - (days * DAY)) / HOUR);
  const minutes = Math.floor((diff - (days * DAY) - (hours * HOUR)) / MINUTE);

  return {
    days,
    hours,
    minutes,
  };
};

export const getTimeSinceText = (timestamp: number): string => {
  const { days, hours, minutes } = getTimeSince(timestamp);
  if (days === 0 && hours === 0 && minutes < 2) {
    return 'just now';
  } else if (days === 0 && hours === 0) {
    return `${ minutes } minutes ago`;
  } else if (days === 0 && hours === 1) {
    return `${ hours } hour ${ minutes } minutes ago`;
  } else if (days === 0 && hours < 3) {
    return `${ hours } hours ${ minutes } minutes ago`;
  } else if (days === 0) {
    return `${ hours } hours ago`;
  } else if (days === 1) {
    return `${ days } day ago`;
  } else if (days <= 2) {
    return `${ days } days ago`;
  }

  return `${ days } days ago`;
};
